var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PipelineCandidateRepository, TalentTimelineRepository, ThreadRepository } from './index';
import { container } from 'tsyringe';
import { JobRepository } from '@/packages/v5/jobs/JobRepository';
import { FormResponseRepository } from 'packages/form/entities/legacy/FormResponseRepository';
import { TalentFileRepository } from '@/packages/talent/TalentFileRepository';
export var actions = {
    initialise: function (_a, _b) {
        var commit = _a.commit;
        var jobId = _b.jobId, talentId = _b.talentId;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        commit('setTalentLoading', true);
                        _c = commit;
                        _d = ['setCandidate'];
                        return [4 /*yield*/, (container.resolve(PipelineCandidateRepository)).getCandidateInJob(jobId, talentId)];
                    case 1:
                        _c.apply(void 0, _d.concat([_g.sent()]));
                        _e = commit;
                        _f = ['setJob'];
                        return [4 /*yield*/, (container.resolve(JobRepository)).getJobWithStages(jobId)];
                    case 2:
                        _e.apply(void 0, _f.concat([_g.sent()]));
                        commit('setTalentLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getFormResponses: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, _c = _b.jobId, jobId = _c === void 0 ? null : _c;
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit('setFormsLoading', true);
                        return [4 /*yield*/, container.resolve(FormResponseRepository).listForTalent(talentId, null, jobId)];
                    case 1:
                        items = (_d.sent()).items;
                        commit('setForms', items);
                        commit('setFormsLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getFilesForTalent: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit('setFilesLoading', true);
                        _c = commit;
                        _d = ['setFiles'];
                        return [4 /*yield*/, container.resolve(TalentFileRepository).allFilesForTalent(talentId, jobId)];
                    case 1:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setFilesLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getThreadsForTalent: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('setThreadsLoading', true);
                        return [4 /*yield*/, container.resolve(ThreadRepository).getThreadsForTalent(talentId, jobId)];
                    case 1:
                        items = (_c.sent()).items;
                        commit('setThreads', items);
                        commit('setThreadsLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getAndSelectThread: function (_a, _b) {
        var commit = _a.commit;
        var threadId = _b.threadId, talentId = _b.talentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit('setThreadLoading', true);
                        _c = commit;
                        _d = ['setSelectedThread'];
                        return [4 /*yield*/, container.resolve(ThreadRepository).getTalentThread(threadId, talentId, jobId)];
                    case 1:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setThreadLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getTimelineForTalent: function (_a, talentId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('setTimelineLoading', true);
                        return [4 /*yield*/, container.resolve(TalentTimelineRepository).getTimelineForTalent(talentId)];
                    case 1:
                        items = (_b.sent()).items;
                        commit('setTimeline', items);
                        commit('setTimelineLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
};
